
const AuditOperation = {
    CREATE : "CREATE",
    UPDATE: "UPDATE",
    DELETE: "DELETE",
    READ: "READ",
};

export {AuditOperation};
